export default __webpack_public_path__ + "static/media/pupil_logo.805293c4.jpg";